import axios from "axios";
import { IP } from "./config";

// 查询
export async function selectCardCoupon(data) {
  var resp = await axios.post(`${IP}/cardCoupon/select`, { ...data });
  return resp.data;
}

// 新增
export async function addCardCoupon(data) {
  var resp = await axios.post(`${IP}/cardCoupon/add`, {
    ...data,
  });
  return resp.data;
}

// 批量新增
export async function addCardCouponCardList(data) {
  var resp = await axios.post(`${IP}/cardCoupon/addCardCouponCardList`, {
    ...data,
  });
  return resp.data;
}

// 修改
export async function updateCardCoupon(data) {
  var resp = await axios.post(`${IP}/cardCoupon/update`, {
    ...data,
  });
  return resp.data;
}

// 激活
export async function updateJihuoStatus(data) {
  var resp = await axios.post(`${IP}/cardCoupon/updateJihuo`, {
    ...data,
  });
  return resp.data;
}

// 删除
export async function deleteCardCoupon(data) {
  var resp = await axios.post(`${IP}/cardCoupon/delete`, {
    ...data,
  });
  return resp.data;
}

// 导入物流单号
export async function updateSendState(data) {
  var resp = await axios.post(`${IP}/cardCoupon/updateSendState`, {
    ...data,
  });
  return resp.data;
}

/* 查询已发货数量和未发货数量 */
export async function selectSum() {
  var resp = await axios.post(`${IP}/cardCoupon/selectSum`, {});
  return resp.data;
}

/* 查询每天卡券的限制数量 */
export async function selectCouponConfig() {
  var resp = await axios.post(`${IP}/cardCoupon/selectCouponConfig`, {
  });
  return resp.data;
}

/* 新增每天卡券的限制数量 */
export async function addCouponConfig(data) {
  var resp = await axios.post(`${IP}/cardCoupon/addCouponConfig`, {
    ...data,
  });
  return resp.data;
}

/* 删除每天卡券的限制数量 */
export async function deleteCouponConfig(id) {
  var resp = await axios.post(`${IP}/cardCoupon/deleteCouponConfig`, {
    id,
  });
  return resp.data;
}
